import React, { Component, useEffect, useState } from 'react';
import CountUp from 'react-countup';
import { connect } from 'react-redux';
import axios from 'axios';
import Select from "react-select";
import { Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { API_BASE_URL } from '../../config.js'
import DataTable, { defaultThemes } from 'react-data-table-component';

import Pagination from '../Pagination/Paginations.js';
import EntriesSelector from '../Pagination/EntriesSelector';
import useSortData from "../Pagination/SortData";



import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';

// import DataTable from 'datatables.net-react';
// import DT from 'datatables.net-dt';

// DataTable.use(DT);
import {
	statisticsAction,
	statisticsCloseAction
} from '../../actions/settingsAction.js';
import { Link } from 'react-router-dom/cjs/react-router-dom.min.js';
const Exchangeshift = (props) => {
	const sparkline1 = React.createRef();
	const sparkline2 = React.createRef();
	const sparkline3 = React.createRef();
	const sparkline4 = React.createRef();


	const handleStatistics = (e) => {
		statisticsAction(e)
	}
	const closeStatistics = (e) => {
		statisticsCloseAction(e)
	}

	const { fixNavbar, statisticsOpen, statisticsClose } = props;
	
	 const [toggle,setToggle]=useState(false);
	const today = new Date().toISOString().split("T")[0];


	const [user, setUser] = useState({
        exchange_date:"",
		
    })


    const [exchangeshift, setExchangeShift] = useState({
  department: "",
  exchange_from: "",
  exchange_to: "",
  exchange_shift_date: "",
});

const [isExchanging, setIsExchanging] = useState(false);


const handleExchangeInput = (e) => {
  const { name, value } = e.target;
  setExchangeShift((prev) => ({ ...prev, [name]: value }));
};

// react-select passes the picked option instead of an event
const handleExchangeSelect = (name) => (selected) => {
  setExchangeShift((prev) => ({ ...prev, [name]: selected ? selected.value : "" }));
};

const exchangeSelectStyles = {
  control: (base) => ({
    ...base,
    minHeight: "38px",
    borderRadius: "4px",
    borderColor: "#ced4da",
    boxShadow: "none",
    fontSize: "13px",
    "&:hover": { borderColor: "#b3b3b3" }
  }),
  menu: (base) => ({ ...base, borderRadius: "4px", zIndex: 9999 }),
  option: (base, state) => ({
    ...base,
    fontSize: "13px",
    padding: "6px 10px",
    backgroundColor: state.isFocused ? "#f8f9fa" : "white",
    color: "#333"
  })
};



useEffect(() => {
  if (exchangeshift.department) {
    fetch(`${API_BASE_URL}/showdeptbaseemp/${exchangeshift.department}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
    })
      .then((res) => res.json())
      .then((data) => setEmployeeDropdownOptions(data))
      .catch((err) => console.error("Error fetching employees:", err));
  }
}, [exchangeshift.department]);



	

	
	const history = useHistory();
	const [data, setData]= useState([]);
	const [dataval, setdataval]= useState([]);
    const [isVisible, setIsVisible] = useState(false);
	const [urlres, setUrlRes] = useState(false);
	const [style1,setStyle1]=useState(false);
	const [records, setRecords] = useState([]);
	const [loading, setLoading] = useState(false);
	const { sortConfig, sortData, handleSort } = useSortData();


    const handelInput = (event) => {
        event.preventDefault();
        const { name, value } = event.target;
        console.log(name, value)
        setUser({ ...user, [name]: value });

        if (event.target.value === '1') {
            setIsVisible(true);
          } else {
            setIsVisible(false);
          }
    }


		const [searchTerm, setSearchTerm] = useState("");
		const [currentPage, setCurrentPage] = useState(1);
		const [entriesPerPage,setEntriesPerPage]=useState(10);
		const filteredItems = records.filter((item) => {
  const search = searchTerm.toLowerCase();

  return (
    String(item.shift_date ?? "").includes(search) ||
    String(item.from_emp ?? "").includes(search) ||
    String(item.to_emp ?? "").includes(search) ||
    String(item.shift_from ?? "").toLowerCase().includes(search) ||
    String(item.shift_to ?? "").toLowerCase().includes(search) ||
    String(item.request_on ?? "").includes(search)
  );
});

		const totalPages = Math.ceil(filteredItems.length / entriesPerPage);
		const indexOfLast = currentPage * entriesPerPage;
		const indexOfFirst = indexOfLast - entriesPerPage;
		// const filteredData = filteredItems.slice(indexOfFirst, indexOfLast);
		const sortedItems = sortData(filteredItems);
		const filteredData = sortedItems.slice(indexOfFirst, indexOfLast);

		const startIndex = (currentPage - 1) * entriesPerPage;
	  
		useEffect(() => {
		  setCurrentPage(1);
		}, [searchTerm]);
	  
		
	
	  const handleSearch = (event) => {
		//console.log(event.target.value);
		 setSearchTerm(event.target.value);
	  };
	
	
	   const clearInput = () => {
		setSearchTerm("");
	  };



	    const handleDepartment = async () => {
	  
			axios.get(API_BASE_URL +'/dept_list_under_incharge/', {
            headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
        })
			.then(res1 => setdataval(res1.data))
			.catch(err => console.log(err))
		   };
	  
	  
		   useEffect(() => {
			handleDepartment();
		  }, []);


 const [department, setDepartmentValue] = useState("ALL");
 const [employeeDropdownOptions,setEmployeeDropdownOptions]=useState([]);
 const [employeedet,setEmployeeValue] = useState("ALL");


 // options for the searchable dropdowns in the Add form
 const exchangeDeptOptions = dataval.map(option => ({
   value: String(option.department_id),
   label: option.department_name
 }));

 const exchangeEmpOptions = employeeDropdownOptions.map(option => ({
   value: String(option.user_id),
   label: `${option.first_name} ${option.last_name} (${option.employee_id})`
 }));


 const handleFirstDropdownChange = (event) => {
    const value = event.target.value;
    setDepartmentValue(value);

    // Trigger API call based on the selected value
    fetchSecondDropdownOptions(value);
  };


     // Fetch options for the second dropdown
     const fetchSecondDropdownOptions = async (selectedValue) => {

      try {
      
    const response = await fetch(
          API_BASE_URL + '/showdeptbaseemp/'+selectedValue, {
            headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
        }
        ); // Replace with your API URL
  
        const data = await response.json();
        console.log(data);

        setEmployeeDropdownOptions(data); // Assuming the API returns an array of options
      } catch (error) {
        console.error("Error fetching second dropdown options:", error);
      }
    };


      // Handle second dropdown change
      const handleSecondDropdownChange = (event) => {
        // setSecondDropdownValue(event.target.value);
        setEmployeeValue(event.target.value);
      };





  useEffect(()=> {
	axios.get(API_BASE_URL +'/fetchshift', {
		headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
	})

	//.then(res =>console.log(res.data))
	 .then(res => setData(res.data))
	.catch(err => console.log(err));
},[])




const handleExchangeSubmit = async (e) => {
  e.preventDefault();

  if (isExchanging) {
    return;
  }

  const { department, exchange_from, exchange_to, exchange_shift_date } = exchangeshift;


// alert( department+', '+exchange_from+', '+exchange_to+', '+exchange_shift_date);
 

  if (!department || !exchange_from || !exchange_to || !exchange_shift_date) {
    toast.error("Please fill all required fields!", {
						position: "bottom-right",
						autoClose: 5000,
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true,
						progress: undefined,
						theme: "colored",
	  
					});
    return;
  }

  setIsExchanging(true);

  try {
    const res = await axios.post(
      `${API_BASE_URL}/process_shift_exchange`,
      {
        department_id: department,
        employee_from_id:exchange_from,
        employee_to_id:exchange_to,
        shift_date: exchange_shift_date,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          "Content-Type": "application/json",
        },
      }
    );

    var status = res.data.status;

  if (status=='success')
  {
  toast.success(res.data.message, {
			position: "bottom-right",
			autoClose: 5000,
			hideProgressBar: false,
			closeOnClick: true,
			pauseOnHover: true,
			draggable: true,
			progress: undefined,
			theme: "colored",
			});
			const timeout = setTimeout(() => {
					window.location.reload(); // Reload the current page
				}, 5000); // Refresh after 5 seconds
  
				return () => {
					clearTimeout(timeout); // Cleanup the timeout if the component unmounts
				};

  setExchangeShift({
    department: "",
    exchange_from: "",
    exchange_to: "",
    exchange_shift_date: "",
  });
}else {
     setIsExchanging(false);

     toast.error(res.data.message, {
						position: "bottom-right",
						autoClose: 5000,
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true,
						progress: undefined,
						theme: "colored",

					});
    }
  } catch (err) {
    setIsExchanging(false);
    console.error("Error submitting exchange shift:", err);
    toast.error("Something went wrong!");
  }
};






const handleSubmit = async (e) => {
    e.preventDefault();
	setLoading(true);
    try {
      const response = await axios.post(API_BASE_URL +'/incharge_shift_exchange',
		{ exchange_date: user.exchange_date}, 
		{
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		}

);
//  console.log(response.data.exchange_shift);
      setRecords(response.data.exchange_shift); // Assuming the API response contains the records in `response.data`
	  setLoading(false);
	} catch (error) {
      console.error("Error fetching data:", error);
    }
  };


  useEffect(()=> {
	axios.post(API_BASE_URL +'/incharge_shift_exchange',{ exchange_date: user.exchange_date }, {
		headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
	})

	//  .then(response =>console.log(response))
	 .then(response => setRecords(response.data.exchange_shift))
	.catch(err => console.log(err));
},[])




const columns = [
  { label: "From Employee", key: "from_emp", sortable: true },
  { label: "To Employee", key: "to_emp", sortable: true },
  { label: "Shift Date", key: "shift_date", sortable: true },
  { label: "Shift From", key: "shift_from", sortable: true },
  { label: "Shift To", key: "shift_to", sortable: true },
  { label: "Request On", key: "request_on", sortable: true },
  { label: "Hr Approval", key: "hr_approval_status", sortable: true },
];

	return (
		<>
			<style>{`.react-datepicker-popper { z-index: 9999 !important; }`}</style>

			<div>
				<div>
					<div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
						<div className="container-fluid">

							<ToastContainer />
						
						</div>
					</div>

                    <div className="section-body mt-3">
										<div className="container-fluid">
											<div className="row clearfix">
												<div className="col-md-12">
                                                <button style={{width:'100px',float: 'right',margin: '10px 35px 15px 10px'}}
                                                            type="button"
                                                            className="btn btn-primary"
                                                            onClick={()=>setToggle(!toggle)}
                                                        >
                                                            <i className="fe fe-plus mr-2" />
                                                            Add
                                                        </button>
                                                        {toggle && (
													<div className="card">
														{/* <div className="card-header">
															<h3 className="card-title">My Shift</h3>
														</div> */}
														<div className="card-body">

                                                      


                                                       


															<form onSubmit={handleExchangeSubmit}>
  <div className="row">
    {/* Department */}
    <div className="col-md-3 col-sm-12">
      <div className="form-group required-tooltip">
        <label className="form-label">
          Department
        </label>
        <Select
          classNames={{ control: () => "required-select" }}
          classNamePrefix="react-select"
          name="department"
          options={exchangeDeptOptions}
          value={exchangeDeptOptions.find(opt => opt.value === String(exchangeshift.department)) || null}
          onChange={handleExchangeSelect("department")}
          isSearchable={true}
          placeholder="Select Department"
          styles={exchangeSelectStyles}
        />
      </div>
    </div>

    {/* Exchange From */}
    <div className="col-md-3 col-sm-12">
      <div className="form-group required-tooltip">
        <label className="form-label">
          Exchange From
        </label>
        <Select
          classNames={{ control: () => "required-select" }}
          classNamePrefix="react-select"
          name="exchange_from"
          options={exchangeEmpOptions}
          value={exchangeEmpOptions.find(opt => opt.value === String(exchangeshift.exchange_from)) || null}
          onChange={handleExchangeSelect("exchange_from")}
          isSearchable={true}
          isDisabled={employeeDropdownOptions.length === 0}
          placeholder="Select From Employee"
          styles={exchangeSelectStyles}
        />
      </div>
    </div>

    {/* Exchange To */}
    <div className="col-md-3 col-sm-12">
      <div className="form-group required-tooltip">
        <label className="form-label">
          Exchange To
        </label>
        <Select
          classNames={{ control: () => "required-select" }}
          classNamePrefix="react-select"
          name="exchange_to"
          options={exchangeEmpOptions}
          value={exchangeEmpOptions.find(opt => opt.value === String(exchangeshift.exchange_to)) || null}
          onChange={handleExchangeSelect("exchange_to")}
          isSearchable={true}
          isDisabled={employeeDropdownOptions.length === 0}
          placeholder="Select To Employee"
          styles={exchangeSelectStyles}
        />
      </div>
    </div>

    {/* Exchange Date */}
    <div className="col-md-3 col-sm-6">
      <div className="form-group required-tooltip">
        <label className="form-label">
          Exchange Date
        </label>
        <DatePicker
          selected={exchangeshift.exchange_shift_date ? new Date(exchangeshift.exchange_shift_date) : null}
          onChange={(date) => {
            const value = date ? date.toLocaleDateString('en-CA') : "";
            setExchangeShift((prev) => ({ ...prev, exchange_shift_date: value }));
          }}
          dateFormat="yyyy-MM-dd"
          placeholderText="Select Exchange Date"
          className="form-control required-input"
          wrapperClassName="w-100"
        />
      </div>
    </div>
  </div>

  <div className="row">
    <div className="col-md-4 col-sm-6">
      <div className="form-group">
        <button
          type="submit"
          className="btn btn-primary"
          disabled={
            isExchanging ||
            !exchangeshift.department ||
            !exchangeshift.exchange_from ||
            !exchangeshift.exchange_to ||
            !exchangeshift.exchange_shift_date
          }
        >
          {isExchanging ? "Submitting..." : "Submit"}
        </button>
      </div>
    </div>
  </div>
</form>

                                               
														</div>
													</div>
                                                     )}
												</div>
					
											</div>
										</div>
									</div>


					 <div className="section-body mt-3">
										<div className="container-fluid">
											<div className="row clearfix">
												<div className="col-md-12">
													<div className="card">
														<div className="card-header">
															<h3 className="card-title d-flex align-items-center" style={{ color: "#1d3a8a", fontWeight: 600 }}>
																<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 16 16" fill="#1d3a8a" style={{ marginRight: "8px", verticalAlign: "-3px" }}>
																	<path d="M4 .5a.5.5 0 0 0-1 0V1H2a2 2 0 0 0-2 2v1h16V3a2 2 0 0 0-2-2h-1V.5a.5.5 0 0 0-1 0V1H4zM16 14V5H0v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2m-5.146-5.146-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708.708"/>
																</svg>
																Shift Exchanges
															</h3>
														</div>
														<div className="card-body">
															 <form onSubmit={handleSubmit} >
					
																<div class="row align-items-end">
					
																<div className="col-md-4 col-sm-6">
																	<div className="form-group mb-2">
																	<label className="form-label">Date</label>
																	<DatePicker
																		selected={user.exchange_date ? new Date(user.exchange_date) : null}
																		onChange={(date) => {
																			const value = date ? date.toLocaleDateString('en-CA') : "";
																			setUser(prev => ({ ...prev, exchange_date: value }));
																		}}
																		dateFormat="dd-MM-yyyy"
																		placeholderText="Select Date"
																		className="form-control"
																		wrapperClassName="w-100"
																		showMonthDropdown
																		showYearDropdown
																		dropdownMode="select"
																	/>
																
																	</div>
																</div>


                                                                <div className="col-md-4 col-sm-6">
														<div className="form-group mb-2">
					
													<button type="submit" className="btn btn-primary">
													GET
												</button>
					
												
												</div>
												</div>
					
																
					
					
													</div>

													
															 </form>
														</div>
													</div>
												</div>
					
											</div>
										</div>
									</div>


										<div className="section-body">
											<div className="container-fluid">
												<div className="tab-content">
													<div className="tab-pane fade show active" id="Employee-list" role="tabpanel">
														<div className="card">
					
															<div className="card-header">
																<div
  className="card-options"
  style={{
    display: "flex",
    alignItems: "center",
    gap: "12px",
  }}
>
  <EntriesSelector
    entriesPerPage={entriesPerPage}
    setEntriesPerPage={setEntriesPerPage}
    setCurrentPage={setCurrentPage}
  />

  {/* 🔽 SEARCH BOX WRAPPER */}
  <div style={{ position: "relative", width: "200px" }}>
    <input
      type="text"
      className="form-control form-control-sm"
      placeholder="Search"
      value={searchTerm}
      onChange={(e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1);
      }}
      style={{
        width: "100%",
        height: "30px",
        fontSize: "13px",
        borderRadius: "4px",
        paddingRight: "28px", // ✅ space for X
      }}
    />

    {searchTerm.length > 0 && (
      <span
        onClick={clearInput}
        style={{
          position: "absolute",
          right: "8px",        // ✅ INSIDE input
          top: "50%",          // ✅ vertically centered
          transform: "translateY(-50%)",
          cursor: "pointer",
          color: "#aaa",
          fontSize: "16px",
          userSelect: "none",
        }}
      >
        ✖
      </span>
    )}
  </div>
</div>
															</div>
					
															{/* <div>
																<DataTable 
																columns={column} 
																data={data}
																customStyles={customStyles}
																pagination 
																highlightOnHover
																responsive
																paginationPerPage={10}
																paginationRowsPerPageOptions={[25,50,100,500]}
																className="table table-striped table-bordered"> 
															</DataTable>
															</div> */}
					
					
					
					
					
					
					
					{/* Loading Spinner */}
					{loading && (
																<div className="card-body">
																<div class="d-flex justify-content-center">
						   <div class="spinner"></div>
						   </div>
						   </div>
						  )}
					
					{!loading && (
															<div className="card-body">
															
																<div className="table-responsive sticky-table-wrap">
							
					
						
						  
								<table className="table table-hover table-striped table-vcenter text-nowrap mb-0 sticky-table">
																		<thead>
																			<tr>
					
																			   {columns.map((col) => (
																<th
																	key={col.key}
																	onClick={col.sortable ? () => handleSort(col.key) : null}
																	style={{ cursor: col.sortable ? "pointer" : "default" }}
																>
																	{col.label}
																	{col.sortable && (
																sortConfig.key === col.key
																	? (sortConfig.direction === "asc" ? " ▲" : " ▼")
																	: " ⇅"   // <-- DEFAULT SORT ICON
																)}
																	</th>
																))}
																				
																			</tr>
																		</thead>
																		<tbody>
																		{records.length > 0 ? (
																				filteredData.map((record) => (
																					<tr key={record.shift_date}>
																					<td>{record.from_emp}</td>
																					<td>{record.to_emp}</td>
																					<td>{record.shift_date}</td>
																					<td>{record.shift_from}</td>
																					<td>{record.shift_to}</td>
																					<td>{record.request_on}</td>
																					<td>{ReactHtmlParser(record.hr_approval_status)}</td>
																				</tr>
																				))
																			) : (
																				<tr>
																				<td colSpan="7" style={{ color: 'red', textAlign: 'center',fontWeight: "bold" }}>No records found</td>
																				</tr>
																			)}
					
																
																		</tbody>
																	</table>
																</div>
															
												<Pagination
												currentPage={currentPage}
												totalPages={totalPages}
												onPageChange={setCurrentPage}
												/>	
													
					
															</div> 
					)
					}
														</div>
													</div>
						
												
												</div>
											</div>
										</div>

				</div>
			</div>




		</>
	);

}



const mapStateToProps = (state) => ({
	fixNavbar: state.settings.isFixNavbar,
	statisticsOpen: state.settings.isStatistics,
	statisticsClose: state.settings.isStatisticsClose,
})

const mapDispatchToProps = (dispatch) => ({
	statisticsAction: (e) => dispatch(statisticsAction(e)),
	statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e))
})
export default connect(mapStateToProps, mapDispatchToProps)(Exchangeshift);